export default __webpack_public_path__ + "de4ddadb27d0d2272d668befd64f9643.png";